import { FC, useCallback, useEffect, useRef, useState } from "react";
import { appInsights, reactPlugin, withAITracking } from "../../../appInsights";
import { useNavigate } from "react-router-dom";
import { Col, Card, Table, Pagination, Select, Row, Spin, Input, Space, Button, Tooltip, DatePicker } from "antd";
import { CaretDownOutlined, CloseOutlined, SearchOutlined } from "@ant-design/icons";
import { Subscription } from "rxjs";
import Highlighter from "react-highlight-words";
// import moment from "moment";
import isEmpty from "lodash/isEmpty";

// include local dependencies
import DonutChart from "./donut-chart";
import "./encounters-data.scss";
import { ASC, DESC, claimTypeLegendColors } from "@utils/constants";
import LineChart from "./line-chart";
import memberDetailsService from "@services/memberDetails.service";
import membersService from "@services/members.service";
import { routeMap } from "@utils/constants";
// import CustomTooltip from "@pages/tool-tip";
// import { formatDefaultDate } from "@pages/utils/utils";
import { formatDisplayDate, fixedDecimal, centricClientCheck, getClientName } from "@utils/helpers";
import Icon from "@assets/icon_config";
import HealthemSpinner from "@components/healthemSpinner/healthemSpinner";
// import NotesModal from "@components/high-cost-patient-report/notesModal/notesModal";
// import HighCostPatientService from "@services/high-cost-patient.service";
import DataNotFound, { TableLocale } from "@components/noDataFound";
import { NO_DATA_FOUND } from "../../../constants/constants";
import { filter } from "lodash";
import moment from "moment";

const { RangePicker } = DatePicker;

const rowsPerPageArray: any[] = ["5", "10", "15", "20", "25", "30", "35", "40", "45", "50"];

const EncountersData: FC<any> = () => {
  // const appliedFilters = true;
  // const [drawerViewtype, setDrawerViewtype] = useState(layerViews[0]);
  // const [isOpenDrawer, toggleDrawerHandler] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [loadingForEncounter, setEncounterFlag] = useState(false);
  const [encounterData, setEncounterData] = useState<any>({});
  const [alllMemberData, setAllMemberData] = useState<any[]>([]);
  // const [copyAllMemberData, setCopyAllMemberData] = useState<any[]>([]);
  const [searchBy, setSearchBy] = useState<any>();
  const [searchKeyword, setSearchKeyword] = useState<any>();
  const [sortBy, setSortByFilter] = useState(null);
  // const [searchValue, setSearchValue] = useState();
  const [patientId, setPatientId] = useState(Number);
  const [claim_type, setClaim_type] = useState<string[]>([]);
  const activeSearchCol = useRef<string>("");
  const [activeSearchTextDate, setActiveSearchTextDate] = useState<any>("");
  const [activeSearchTextClaimType, setActiveSearchTextClaimType] = useState<any>("");
  const [activeSearchTextClaimServiceType, setActiveSearchTextClaimServiceType] = useState<any>("");
  const [activeSearchTextCost, setActiveSearchTextCost] = useState<any>("");
  const [activeSearchTextProvider, setActiveSearchTextProvider] = useState<any>("");
  const [activeSearchTextHealthPlan, setActiveSearchTextHealthPlan] = useState<any>("");
  const [activeSearchTextProviderSpeciality, setActiveSearchTextProviderSpeciality] = useState<any>("");
  const [activeSearchTextProviderAddress, setActiveSearchTextProviderAddress] = useState<any>("");
  const [activeSearchTextLocation, setActiveSearchTextLocation] = useState<any>("");
  const [sortOrder, setSortOrder] = useState<any>("");
  const currentSortType = useRef(null);
  const isCentric = centricClientCheck();
  const [reminderStartFilter, setReminderStartFilter] = useState(moment().subtract(isCentric ? 11 : 11, "months").format("YYYY-MM"));
  const [reminderEndFilter, setReminderEndFilter] = useState(moment().format("YYYY-MM"));
  // const [refreshDate, setRefreshDate] = useState<any>("");
  // const [showNotesModal, setNotesModal] = useState<boolean>(false);

  useEffect(() => {
    console.log("EncountersData.useEffect1");
    appInsights.trackPageView({ name: "Encounters Data" });
  }, []);

  useEffect(() => {
    console.log("EncountersData.useEffect2");
    setColumns(tableColumns);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    activeSearchTextDate,
    activeSearchTextClaimType,
    activeSearchTextClaimServiceType,
    activeSearchTextCost,
    activeSearchTextProvider,
    activeSearchTextProviderSpeciality,
    activeSearchTextHealthPlan,
    activeSearchTextProviderAddress,
    activeSearchTextLocation,
  ]);

  // useEffect(() => {
  //   console.log("EncountersData.useEffect3");
  //   const fetchRefreshDate = () => {
  //     HighCostPatientService.getRefreshDate().subscribe({
  //       next: (response: any) => {
  //         // setRefreshDate(moment.utc(response.data.yearMonth));
  //       },
  //       error: (error) => {
  //         console.log(error);
  //       },
  //     });
  //   };
  //   fetchRefreshDate();
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  const highlighterColorCoded = (text: any, textTosearch: string) => {
    return (
      <span style={{ display: "flex", justifyContent: isCentric ? "left" : "center" }}>
        <Tooltip placement="topLeft" title={text ? text.toString() : ""}>
          <Highlighter highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }} searchWords={[textTosearch]} autoEscape textToHighlight={text ? `${text.toString()}` : ""} />
        </Tooltip>
      </span>
    );
  };

  const inputref = useRef<any>(null);
  const tableColumns = filter(
    [
      {
        // title: "DATE",
        dataIndex: "date",
        key: "date",
        sorter: {},
        // ellipsis: {
        //   showTitle: false,
        // },
        render: (date: any) => {
          const formatedDate = formatDisplayDate(date, "reminderDateActualFormat", "");
          return highlighterColorCoded(formatedDate, activeSearchTextDate);
        },
        isSearchDisplay: false,
        filterDropdown: ({ confirm }: any) => {
          // return <GetFilterDropDown searchByKey="date" activeSearchText={activeSearchTextDate} onactiveSearchTextChange={setActiveSearchTextDate} confirm={confirm} />;
          return (
            <div style={{ padding: "10px" }}>
              <Input
                // autoFocus
                ref={inputref}
                style={{ marginBottom: 8, display: "block" }}
                value={activeSearchTextDate}
                onChange={(e) => {
                  e.preventDefault();
                  setActiveSearchTextDate(e.target.value);
                  setColumns(tableColumns);
                }}
                onKeyPress={(e: any) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    setCurrentPage(1);
                    onSearch("date", activeSearchTextDate);
                    confirm({ closeDropdown: true });
                  }
                }}
                onPressEnter={(e: any): any => {
                  e.stopPropagation();
                }}
              />
              <Space>
                <Button
                  type="primary"
                  icon={<SearchOutlined />}
                  size="small"
                  style={{ width: 90 }}
                  onClick={(e) => {
                    setCurrentPage(1);
                    onSearch("date", activeSearchTextDate);
                    confirm({ closeDropdown: true });
                  }}
                >
                  Search
                </Button>

                <Button
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    const cMember = membersService?.getCurrentMember;
                    pid.current = parseInt(cMember?.patient_id);

                    activeSearchCol.current = "";
                    setColumns(tableColumns);

                    setActiveSearchTextDate("");
                    setSearchBy("");
                    setSearchKeyword("");
                    applyColumnSearch("", "", true);
                    setCurrentPage(1);
                    confirm({ closeDropdown: true });
                  }}
                  size="small"
                  style={{ width: 90 }}
                >
                  Reset
                </Button>
              </Space>
            </div>
          );
        },
        onFilterDropdownOpenChange: (visible: any) => {
          if (visible) {
            setTimeout(() => inputref.current?.select(), 100);
          }
        },
        filterIcon: (filtered: any) => <SearchOutlined style={{ color: "date" === activeSearchCol.current ? "#EF6D2A" : undefined }} />,
        title: () => {
          const column = getSeachIndex();
          return getSearchField(column, "date", "DATE");
        },
        width: 110,
      },
      {
        // title: "CLAIM TYPE",
        dataIndex: "claim_type",
        key: "claim_type",
        sorter: {},
        // ellipsis: {
        //   showTitle: false,
        // },
        render: (claim_type: any) => {
          return highlighterColorCoded(claim_type, activeSearchTextClaimType);
        },
        isSearchDisplay: false,
        filterIcon: (filtered: any) => <SearchOutlined style={{ color: "claim_type" === activeSearchCol.current ? "#EF6D2A" : undefined }} />,
        filterDropdown: ({ confirm }: any) => {
          // return <GetFilterDropDown searchByKey="claim_type" activeSearchText={activeSearchTextClaimType} onactiveSearchTextChange={setActiveSearchTextClaimType} confirm={confirm}/>;
          return (
            <div style={{ padding: "10px" }}>
              <Input
                // autoFocus
                ref={inputref}
                style={{ marginBottom: 8, display: "block" }}
                value={activeSearchTextClaimType}
                onChange={(e) => {
                  e.preventDefault();
                  setActiveSearchTextClaimType(e.target.value);
                  setColumns(tableColumns);
                }}
                onKeyPress={(e: any) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    setCurrentPage(1);
                    onSearch("claim_type", activeSearchTextClaimType);
                    confirm({ closeDropdown: true });
                  }
                }}
                onPressEnter={(e: any): any => {
                  e.stopPropagation();
                }}
              />
              <Space>
                <Button
                  type="primary"
                  icon={<SearchOutlined />}
                  size="small"
                  style={{ width: 90 }}
                  onClick={(e) => {
                    setCurrentPage(1);
                    onSearch("claim_type", activeSearchTextClaimType);
                    confirm({ closeDropdown: true });
                  }}
                >
                  Search
                </Button>

                <Button
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    const cMember = membersService?.getCurrentMember;
                    pid.current = parseInt(cMember?.patient_id);

                    activeSearchCol.current = "";
                    setColumns(tableColumns);

                    setActiveSearchTextClaimType("");
                    setSearchBy("");
                    setSearchKeyword("");
                    applyColumnSearch("", "", true);
                    setCurrentPage(1);
                    confirm({ closeDropdown: true });
                  }}
                  size="small"
                  style={{ width: 90 }}
                >
                  Reset
                </Button>
              </Space>
            </div>
          );
        },
        onFilterDropdownOpenChange: (visible: any) => {
          if (visible) {
            setTimeout(() => inputref.current?.select(), 100);
          }
        },
        title: () => {
          const column = getSeachIndex();
          return getSearchField(column, "claim_type", "CLAIM TYPE");
        },
        width: 130,
      },
      {
        dataIndex: "claim_service_type",
        key: "claim_service_type",
        sorter: {},
        render: (claim_service_type: any) => {
          return highlighterColorCoded(claim_service_type, activeSearchTextClaimServiceType);
        },
        isSearchDisplay: false,
        filterIcon: (filtered: any) => <SearchOutlined style={{ color: "claim_service_type" === activeSearchCol.current ? "#EF6D2A" : undefined }} />,
        filterDropdown: ({ confirm }: any) => {
          return (
            <div style={{ padding: "10px" }}>
              <Input
                ref={inputref}
                style={{ marginBottom: 8, display: "block" }}
                value={activeSearchTextClaimServiceType}
                onChange={(e) => {
                  e.preventDefault();
                  setActiveSearchTextClaimServiceType(e.target.value);
                  setColumns(tableColumns);
                }}
                onKeyPress={(e: any) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    setCurrentPage(1);
                    onSearch("claim_service_type", activeSearchTextClaimServiceType);
                    confirm({ closeDropdown: true });
                  }
                }}
                onPressEnter={(e: any): any => {
                  e.stopPropagation();
                }}
              />
              <Space>
                <Button
                  type="primary"
                  icon={<SearchOutlined />}
                  size="small"
                  style={{ width: 90 }}
                  onClick={(e) => {
                    setCurrentPage(1);
                    onSearch("claim_service_type", activeSearchTextClaimServiceType);
                    confirm({ closeDropdown: true });
                  }}
                >
                  Search
                </Button>

                <Button
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    const cMember = membersService?.getCurrentMember;
                    pid.current = parseInt(cMember?.patient_id);

                    activeSearchCol.current = "";
                    setColumns(tableColumns);

                    setActiveSearchTextClaimServiceType("");
                    setSearchBy("");
                    setSearchKeyword("");
                    applyColumnSearch("", "", true);
                    setCurrentPage(1);
                    confirm({ closeDropdown: true });
                  }}
                  size="small"
                  style={{ width: 90 }}
                >
                  Reset
                </Button>
              </Space>
            </div>
          );
        },
        onFilterDropdownOpenChange: (visible: any) => {
          if (visible) {
            setTimeout(() => inputref.current?.select(), 100);
          }
        },
        title: () => {
          const column = getSeachIndex();
          return getSearchField(column, "claim_service_type", <>CLAIM<br />SERVICE TYPE</>);
        },
        width: 160,
      },
      {
        // title: "COST",
        dataIndex: "cost",
        key: "cost",
        sorter: {},
        className: !isCentric && "textAlignRight",
        // ellipsis: {
        //   showTitle: false,
        // },
        render: (cost: any) => {
          return (
            <div style={{ display: "flex", justifyContent: isCentric ? "left" : "flex-end" }}>
              <span style={{ fontWeight: "bold", marginRight: "4px" }}>$</span>
              {highlighterColorCoded(fixedDecimal(cost, 2), activeSearchTextCost)}
            </div>
          );
        },
        isSearchDisplay: false,
        filterIcon: (filtered: any) => <SearchOutlined style={{ color: "cost" === activeSearchCol.current ? "#EF6D2A" : undefined }} />,
        filterDropdown: ({ confirm }: any) => {
          // return <GetFilterDropDown searchByKey="cost" activeSearchText={activeSearchTextCost} onactiveSearchTextChange={setActiveSearchTextCost} confirm={confirm}/>;
          return (
            <div style={{ padding: "10px" }}>
              <Input
                // autoFocus
                ref={inputref}
                style={{ marginBottom: 8, display: "block" }}
                value={activeSearchTextCost}
                onChange={(e) => {
                  e.preventDefault();
                  setActiveSearchTextCost(e.target.value);
                  setColumns(tableColumns);
                }}
                onKeyPress={(e: any) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    setCurrentPage(1);
                    onSearch("cost", activeSearchTextCost);
                    confirm({ closeDropdown: true });
                  }
                }}
                onPressEnter={(e: any): any => {
                  e.stopPropagation();
                }}
              />
              <Space>
                <Button
                  type="primary"
                  icon={<SearchOutlined />}
                  size="small"
                  style={{ width: 90 }}
                  onClick={(e) => {
                    setCurrentPage(1);
                    onSearch("cost", activeSearchTextCost);
                    confirm({ closeDropdown: true });
                  }}
                >
                  Search
                </Button>

                <Button
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    const cMember = membersService?.getCurrentMember;
                    pid.current = parseInt(cMember?.patient_id);

                    activeSearchCol.current = "";
                    setColumns(tableColumns);

                    setActiveSearchTextCost("");
                    setSearchBy("");
                    setSearchKeyword("");
                    applyColumnSearch("", "", true);
                    setCurrentPage(1);
                    confirm({ closeDropdown: true });
                  }}
                  size="small"
                  style={{ width: 90 }}
                >
                  Reset
                </Button>
              </Space>
            </div>
          );
        },
        onFilterDropdownOpenChange: (visible: any) => {
          if (visible) {
            setTimeout(() => inputref.current?.select(), 100);
          }
        },
        title: () => {
          const column = getSeachIndex();
          return getSearchField(column, "cost", "COST");
        },
        width: 100,
      },
      {
        // title: "PROVIDER SPECIALITY",
        dataIndex: "health_plan",
        key: "health_plan",
        sorter: {},
        // ellipsis: {
        //   showTitle: false,
        // },
        render: (health_plan: any) => {
          return <span style={{ display: "flex", justifyContent: isCentric ? "left" : "center" }}>{highlighterColorCoded(health_plan, activeSearchTextHealthPlan)}</span>;
        },
        isSearchDisplay: false,
        filterIcon: (filtered: any) => <SearchOutlined style={{ color: "health_plan" === activeSearchCol.current ? "#EF6D2A" : undefined }} />,
        filterDropdown: ({ confirm }: any) => {
          // return <GetFilterDropDown searchByKey="health_plan" activeSearchText={activeSearchTextProviderSpeciality} onactiveSearchTextChange={setActiveSearchTextProviderSpeciality} confirm={confirm}/>;
          return (
            <div style={{ padding: "10px" }}>
              <Input
                // autoFocus
                ref={inputref}
                style={{ marginBottom: 8, display: "block" }}
                value={activeSearchTextHealthPlan}
                onChange={(e) => {
                  e.preventDefault();
                  setActiveSearchTextHealthPlan(e.target.value);
                  setColumns(tableColumns);
                }}
                onKeyPress={(e: any) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    setCurrentPage(1);
                    onSearch("health_plan", activeSearchTextHealthPlan);
                    confirm({ closeDropdown: true });
                  }
                }}
                onPressEnter={(e: any): any => {
                  e.stopPropagation();
                }}
              />
              <Space>
                <Button
                  type="primary"
                  icon={<SearchOutlined />}
                  size="small"
                  style={{ width: 90 }}
                  onClick={(e) => {
                    setCurrentPage(1);
                    onSearch("health_plan", activeSearchTextHealthPlan);
                    confirm({ closeDropdown: true });
                  }}
                >
                  Search
                </Button>

                <Button
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    const cMember = membersService?.getCurrentMember;
                    pid.current = parseInt(cMember?.patient_id);

                    activeSearchCol.current = "";
                    setColumns(tableColumns);

                    setActiveSearchTextHealthPlan("");
                    setSearchBy("");
                    setSearchKeyword("");
                    applyColumnSearch("", "", true);
                    setCurrentPage(1);
                    confirm({ closeDropdown: true });
                  }}
                  size="small"
                  style={{ width: 90 }}
                >
                  Reset
                </Button>
              </Space>
            </div>
          );
        },
        onFilterDropdownOpenChange: (visible: any) => {
          if (visible) {
            setTimeout(() => inputref.current?.select(), 100);
          }
        },
        title: () => {
          const column = getSeachIndex();
          return getSearchField(column, "health_plan", isCentric ? "HEALTH PLAN" : "PAYOR");
        },
        width: 130,
      },
      {
        // title: "PROVIDER",
        dataIndex: "provider",
        key: "provider",
        sorter: {},
        // ellipsis: {
        //   showTitle: false,
        // },
        render: (provider: any) => {
          return highlighterColorCoded(provider, activeSearchTextProvider);
        },
        isSearchDisplay: false,
        filterIcon: (filtered: any) => <SearchOutlined style={{ color: "provider" === activeSearchCol.current ? "#EF6D2A" : undefined }} />,
        filterDropdown: ({ confirm }: any) => {
          // return <GetFilterDropDown searchByKey="provider" activeSearchText={activeSearchTextProvider} onactiveSearchTextChange={setActiveSearchTextProvider} confirm={confirm}/>;
          return (
            <div style={{ padding: "10px" }}>
              <Input
                // autoFocus
                ref={inputref}
                style={{ marginBottom: 8, display: "block" }}
                value={activeSearchTextProvider}
                onChange={(e) => {
                  e.preventDefault();
                  setActiveSearchTextProvider(e.target.value);
                  setColumns(tableColumns);
                }}
                onKeyPress={(e: any) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    setCurrentPage(1);
                    onSearch("provider", activeSearchTextProvider);
                    confirm({ closeDropdown: true });
                  }
                }}
                onPressEnter={(e: any): any => {
                  e.stopPropagation();
                }}
              />
              <Space>
                <Button
                  type="primary"
                  icon={<SearchOutlined />}
                  size="small"
                  style={{ width: 90 }}
                  onClick={(e) => {
                    setCurrentPage(1);
                    onSearch("provider", activeSearchTextProvider);
                    confirm({ closeDropdown: true });
                  }}
                >
                  Search
                </Button>
                <Button
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    const cMember = membersService?.getCurrentMember;
                    pid.current = parseInt(cMember?.patient_id);
                    activeSearchCol.current = "";
                    setColumns(tableColumns);
                    setActiveSearchTextProvider("");
                    setSearchBy("");
                    setSearchKeyword("");
                    applyColumnSearch("", "", true);
                    setCurrentPage(1);
                    confirm({ closeDropdown: true });
                  }}
                  size="small"
                  style={{ width: 90 }}
                >
                  Reset
                </Button>
              </Space>
            </div>
          );
        },
        onFilterDropdownOpenChange: (visible: any) => {
          if (visible) {
            setTimeout(() => inputref.current?.select(), 100);
          }
        },
        title: () => {
          const column = getSeachIndex();
          return getSearchField(column, "provider", "PROVIDER");
        },
        width: 150,
      },
      {
        // title: "PROVIDER SPECIALITY",
        dataIndex: "provider_speciality",
        key: "provider_speciality",
        sorter: {},
        // ellipsis: {
        //   showTitle: false,
        // },
        render: (provider_speciality: any) => {
          return highlighterColorCoded(provider_speciality, activeSearchTextProviderSpeciality);
        },
        isSearchDisplay: false,
        filterIcon: (filtered: any) => <SearchOutlined style={{ color: "provider_speciality" === activeSearchCol.current ? "#EF6D2A" : undefined }} />,
        filterDropdown: ({ confirm }: any) => {
          // return <GetFilterDropDown searchByKey="provider_speciality" activeSearchText={activeSearchTextProviderSpeciality} onactiveSearchTextChange={setActiveSearchTextProviderSpeciality} confirm={confirm}/>;
          return (
            <div style={{ padding: "10px" }}>
              <Input
                // autoFocus
                ref={inputref}
                style={{ marginBottom: 8, display: "block" }}
                value={activeSearchTextProviderSpeciality}
                onChange={(e) => {
                  e.preventDefault();
                  setActiveSearchTextProviderSpeciality(e.target.value);
                  setColumns(tableColumns);
                }}
                onKeyPress={(e: any) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    setCurrentPage(1);
                    onSearch("provider_speciality", activeSearchTextProviderSpeciality);
                    confirm({ closeDropdown: true });
                  }
                }}
                onPressEnter={(e: any): any => {
                  e.stopPropagation();
                }}
              />
              <Space>
                <Button
                  type="primary"
                  icon={<SearchOutlined />}
                  size="small"
                  style={{ width: 90 }}
                  onClick={(e) => {
                    setCurrentPage(1);
                    onSearch("provider_speciality", activeSearchTextProviderSpeciality);
                    confirm({ closeDropdown: true });
                  }}
                >
                  Search
                </Button>

                <Button
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    const cMember = membersService?.getCurrentMember;
                    pid.current = parseInt(cMember?.patient_id);

                    activeSearchCol.current = "";
                    setColumns(tableColumns);

                    setActiveSearchTextProviderSpeciality("");
                    setSearchBy("");
                    setSearchKeyword("");
                    applyColumnSearch("", "", true);
                    setCurrentPage(1);
                    confirm({ closeDropdown: true });
                  }}
                  size="small"
                  style={{ width: 90 }}
                >
                  Reset
                </Button>
              </Space>
            </div>
          );
        },
        onFilterDropdownOpenChange: (visible: any) => {
          if (visible) {
            setTimeout(() => inputref.current?.select(), 100);
          }
        },
        title: () => {
          const column = getSeachIndex();
          return getSearchField(column, "provider_speciality", "PROVIDER SPECIALITY");
        },
        width: 150,
      },
      {
        // title: "PROVIDER ADDRESS",
        dataIndex: "provider_address",
        key: "provider_address",
        sorter: {},
        // ellipsis: {
        //   showTitle: false,
        // },
        render: (provider_address: any) => {
          return highlighterColorCoded(provider_address, activeSearchTextProviderAddress);
        },
        isSearchDisplay: false,
        filterIcon: (filtered: any) => <SearchOutlined style={{ color: "provider_address" === activeSearchCol.current ? "#EF6D2A" : undefined }} />,
        filterDropdown: ({ confirm }: any) => {
          // return <GetFilterDropDown searchByKey="provider_address" activeSearchText={activeSearchTextProviderAddress} onactiveSearchTextChange={setActiveSearchTextProviderAddress}confirm={confirm} />;
          return (
            <div style={{ padding: "10px" }}>
              <Input
                // autoFocus
                ref={inputref}
                style={{ marginBottom: 8, display: "block" }}
                value={activeSearchTextProviderAddress}
                onChange={(e) => {
                  e.preventDefault();
                  setActiveSearchTextProviderAddress(e.target.value);
                  setColumns(tableColumns);
                }}
                onKeyPress={(e: any) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    setCurrentPage(1);
                    onSearch("provider_address", activeSearchTextProviderAddress);
                    confirm({ closeDropdown: true });
                  }
                }}
                onPressEnter={(e: any): any => {
                  e.stopPropagation();
                }}
              />
              <Space>
                <Button
                  type="primary"
                  icon={<SearchOutlined />}
                  size="small"
                  style={{ width: 90 }}
                  onClick={(e) => {
                    setCurrentPage(1);
                    onSearch("provider_address", activeSearchTextProviderAddress);
                    confirm({ closeDropdown: true });
                  }}
                >
                  Search
                </Button>

                <Button
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    const cMember = membersService?.getCurrentMember;
                    pid.current = parseInt(cMember?.patient_id);

                    activeSearchCol.current = "";
                    setColumns(tableColumns);

                    setActiveSearchTextProviderAddress("");
                    setSearchBy("");
                    setSearchKeyword("");
                    applyColumnSearch("", "", true);
                    setCurrentPage(1);
                    confirm({ closeDropdown: true });
                  }}
                  size="small"
                  style={{ width: 90 }}
                >
                  Reset
                </Button>
              </Space>
            </div>
          );
        },
        onFilterDropdownOpenChange: (visible: any) => {
          if (visible) {
            setTimeout(() => inputref.current?.select(), 100);
          }
        },
        title: () => {
          const column = getSeachIndex();
          return getSearchField(column, "provider_address", "PROVIDER ADDRESS");
        },
        width: 150,
      },
      {
        // title: "LOCATION",
        dataIndex: "location",
        key: "location",
        sorter: {},
        // ellipsis: {
        //   showTitle: false,
        // },
        render: (location: any) => {
          return highlighterColorCoded(location, activeSearchTextLocation);
        },
        isSearchDisplay: false,
        filterIcon: (filtered: any) => <SearchOutlined style={{ color: "location" === activeSearchCol.current ? "#EF6D2A" : undefined }} />,
        filterDropdown: ({ confirm }: any) => {
          // return <GetFilterDropDown searchByKey="location" activeSearchText={activeSearchTextLocation} onactiveSearchTextChange={setActiveSearchTextLocation} confirm={confirm}/>;
          return (
            <div style={{ padding: "10px" }}>
              <Input
                // autoFocus
                ref={inputref}
                style={{ marginBottom: 8, display: "block" }}
                value={activeSearchTextLocation}
                onChange={(e) => {
                  e.preventDefault();
                  setActiveSearchTextLocation(e.target.value);
                  setColumns(tableColumns);
                }}
                onKeyPress={(e: any) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    setCurrentPage(1);
                    onSearch("location", activeSearchTextLocation);
                    confirm({ closeDropdown: true });
                  }
                }}
                onPressEnter={(e: any): any => {
                  e.stopPropagation();
                }}
              />
              <Space>
                <Button
                  type="primary"
                  icon={<SearchOutlined />}
                  size="small"
                  style={{ width: 90 }}
                  onClick={(e) => {
                    setCurrentPage(1);
                    onSearch("location", activeSearchTextLocation);
                    confirm({ closeDropdown: true });
                  }}
                >
                  Search
                </Button>

                <Button
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    const cMember = membersService?.getCurrentMember;
                    pid.current = parseInt(cMember?.patient_id);

                    activeSearchCol.current = "";
                    setColumns(tableColumns);

                    setActiveSearchTextLocation("");
                    setSearchBy("");
                    setSearchKeyword("");
                    applyColumnSearch("", "", true);
                    setCurrentPage(1);
                    confirm({ closeDropdown: true });
                  }}
                  size="small"
                  style={{ width: 90 }}
                >
                  Reset
                </Button>
              </Space>
            </div>
          );
        },
        onFilterDropdownOpenChange: (visible: any) => {
          if (visible) {
            setTimeout(() => inputref.current?.select(), 100);
          }
        },
        title: () => {
          const column = getSeachIndex();
          return getSearchField(column, "location", "LOCATION");
        },
        width: 130,
      },
    ],
    (_col) => {
      return !(!isCentric && ["health_plan", "claim_service_type"].includes(_col.dataIndex));
    }
  );

  const [columns, setColumns] = useState<any[]>(tableColumns);
  const pid = useRef<any>();

  const onSearch = (searchByKey: any, activeSearchText: any) => {
    console.log("EncountersData.onSearch");
    const cMember = membersService?.getCurrentMember;
    pid.current = parseInt(cMember?.patient_id);
    activeSearchCol.current = searchByKey;
    if (searchByKey !== "date") {
      setActiveSearchTextDate("");
    }
    if (searchByKey !== "claim_type") {
      setActiveSearchTextClaimType("");
    }
    if (searchByKey !== "claim_service_type") {
      setActiveSearchTextClaimServiceType("");
    }
    if (searchByKey !== "cost") {
      setActiveSearchTextCost("");
    }
    if (searchByKey !== "provider") {
      setActiveSearchTextProvider("");
    }
    if (searchByKey !== "provider_speciality") {
      setActiveSearchTextProviderSpeciality("");
    }
    if (searchByKey !== "health_plan") {
      setActiveSearchTextHealthPlan("");
    }
    if (searchByKey !== "provider_address") {
      setActiveSearchTextProviderAddress("");
    }
    if (searchByKey !== "location") {
      setActiveSearchTextLocation("");
    }
    setColumns(tableColumns);

    if (searchByKey === "date") {
      let formatedDate = activeSearchText;
      if (activeSearchText.split("-").length === 3) {
        formatedDate = formatDisplayDate(activeSearchText, "defaultDateFormat", "createDateFormat");
      }
      if (formatedDate === "Invalid date") {
        formatedDate = activeSearchText;
      }
      applyColumnSearch(searchByKey, formatedDate, true);
    } else {
      applyColumnSearch(searchByKey, activeSearchText, true);
    }
  };

  // const GetFilterDropDown = (props: any) => {
  //   const inputref = useRef<any>(null);

  //   useEffect(() => {
  //     setTimeout(() => inputref.current?.focus(), 100);
  //   },[])

  //   return (
  //     <div style={{ padding: "10px" }}>
  //       <Input
  //         // autoFocus
  //         ref={inputref}
  //         style={{ marginBottom: 8, display: "block" }}
  //         value={props.activeSearchText}
  //         onChange={(e) => {
  //           e.preventDefault();
  //           props.onactiveSearchTextChange(e.target.value);
  //           setColumns(tableColumns);
  //         }}
  //         onKeyPress={(e: any) => {
  //           if (e.key === "Enter") {
  //             e.preventDefault();
  //             setCurrentPage(1);
  //             onSearch(props.searchByKey, props.activeSearchText);
  //             props.confirm({ closeDropdown: true });
  //           }
  //         }}
  //         onPressEnter={(e: any): any => {
  //           e.stopPropagation();
  //         }}
  //       />
  //       <Space>
  //         <Button
  //           type="primary"
  //           icon={<SearchOutlined />}
  //           size="small"
  //           style={{ width: 90 }}
  //           onClick={(e) => {
  //             setCurrentPage(1);
  //             onSearch(props.searchByKey, props.activeSearchText);
  //             props.confirm({ closeDropdown: true });
  //           }}
  //         >
  //           Search
  //         </Button>

  //         <Button
  //           onClick={(e) => {
  //             e.preventDefault();
  //             e.stopPropagation();
  //             const cMember = membersService?.getCurrentMember;
  //             pid.current = parseInt(cMember?.patient_id);

  //             activeSearchCol.current = "";
  //             setColumns(tableColumns);

  //             props.onactiveSearchTextChange("");
  //             setSearchBy("");
  //             setSearchKeyword("");
  //             applyColumnSearch("", "", true);
  //             setCurrentPage(1);
  //             props.confirm({ closeDropdown: true });
  //           }}
  //           size="small"
  //           style={{ width: 90 }}
  //         >
  //           Reset
  //         </Button>
  //       </Space>
  //   </div>
  //   );
  // };

  let searchColumnIndex = "None";
  const onSearchClick = (columnName: any, isClose?: any, text?: any) => {
    console.log("EncountersData.onSearchClick");
    if (isClose) {
      setSearchBy(undefined);
      setSearchKeyword(undefined);
      if (text) {
        sub?.unsubscribe();
        const cMember = membersService?.getCurrentMember;
        let pId = parseInt(cMember?.patient_id);
        sub = getEncounters({
          id: pId,
          page: currentPage,
          limit: rowsPerPage,
          searchBy: searchBy,
          searchKeyword: searchKeyword,
          sortType: sortOrder,
          startDate: reminderStartFilter,
          endDate: reminderEndFilter,
        });
      }
    }

    setColumns((old) =>
      old.map((h: any) => {
        if (h.dataIndex === columnName) h.isSearchDisplay = true;
        else h.isSearchDisplay = false;
        return h;
      })
    );
    searchColumnIndex = columnName;
  };

  const getSeachIndex = () => {
    // console.log("EncountersData.getSerachIndex");
    return searchColumnIndex;
  };
  let sub: Subscription;

  const applyColumnSearch = (columnName: any, text: any, forceUpdateCurrantPage = false) => {
    console.log("EncountersData.applyColumnSearch", reminderEndFilter);
    let sBy = undefined;
    let sKeyword = undefined;

    if (columnName?.trim() !== "" || text.trim() !== "") {
      sBy = columnName;
      sKeyword = text;
    }
    sub?.unsubscribe();
    const cMember = membersService?.getCurrentMember;
    let pId = parseInt(cMember?.patient_id);

    let currentPageNo = currentPage;
    if (forceUpdateCurrantPage) {
      currentPageNo = 1;
    }
    sub = getEncounters({
      id: pId,
      page: currentPageNo,
      limit: rowsPerPage,
      sortBy,
      searchBy: sBy,
      searchKeyword: sKeyword,
      sortType: currentSortType.current,
      startDate: reminderStartFilter,
      endDate: reminderEndFilter,
    });
    setSearchBy(sBy);
    setSearchKeyword(sKeyword);
  };

  const getSearchField = (column: any, currentColumn: any, labelName: any) => {
    // console.log("EncountersData.getSerachField");
    let value: any;
    var timeout: any = null;
    return (
      <div className="search-title">
        {column === currentColumn ? (
          <div className="searchWrap">
            <input
              id={`SearchVal${currentColumn}`}
              type="text"
              placeholder="Search"
              onClick={(e) => e.stopPropagation()}
              onKeyUp={(e) => {
                clearTimeout(timeout);
                timeout = setTimeout(() => {
                  value = (e.target as HTMLInputElement)?.value;
                  applyColumnSearch(currentColumn, value);
                }, 1000);
              }}
            />
            <CloseOutlined
              style={{ color: "#7a869a" }}
              className="search-icon"
              onClick={(e) => {
                let text = (document.getElementById(`SearchVal${currentColumn}`) as HTMLInputElement)?.value;
                e.stopPropagation();
                onSearchClick("None", true, text && text !== "");
              }}
            />
          </div>
        ) : (
          <span>{labelName}</span>
        )}
      </div>
    );
  };

  const navigate = useNavigate();
  const getCurrentMember = membersService?.getCurrentMember;

  const getEncounters = useCallback(
    ({
      id = patientId,
      page = currentPage,
      limit = rowsPerPage,
      sortBy,
      sortType = sortOrder,
      searchBy,
      searchKeyword,
      claimType = claim_type,
      startDate,
      endDate
    }: any) => {
      setEncounterFlag(true);

      console.log("msh", reminderStartFilter, reminderEndFilter);
      return memberDetailsService.getEncounterInfo(id, page, limit, sortBy, sortType, searchBy, searchKeyword, claimType, startDate, endDate).subscribe({
        next: (v) => {
          setEncounterFlag(false);
          setEncounterData(v?.data?.data);

          setAllMemberData(v?.data?.data?.allMembers);
          // setCopyAllMemberData(v?.data?.data?.allMembers);

          setTotalPages(v?.data?.data?.countOfAllMembers);
        },
        error: (e) => {
          setEncounterFlag(false);
          setEncounterData({});
        },
      });
    },
    [claim_type, currentPage, patientId, rowsPerPage, sortOrder]
  );

  const downloadEncountersTable = () => {
    setEncounterFlag(true);
    return memberDetailsService.getEncounterInfoDownload(patientId, sortBy, sortOrder, searchBy, searchKeyword, claim_type, reminderStartFilter, reminderEndFilter).subscribe({
      next: (v) => {
        setEncounterFlag(false);
        if (v.data.status === "OK") window.open(v.data.data, "_blank");
      },
      error: (e) => {
        setEncounterFlag(false);
      },
    });
  };

  useEffect(() => {
    console.log("EncountersData.useEffect", reminderStartFilter, reminderEndFilter);
    setCurrentPage(1);
    const cMember = getCurrentMember;
    setColumns(tableColumns);
    if (cMember && cMember?.patient_id) {
      let pId = parseInt(cMember?.patient_id);
      setPatientId(pId);
      getEncounters({
        id: pId,
        page: currentPage,
        limit: rowsPerPage,
        sortBy,
        sortType: sortOrder,
        startDate: reminderStartFilter,
        endDate: reminderEndFilter,
        searchBy: searchBy,
        searchKeyword: searchKeyword,
      });
    } else navigate(routeMap["members"]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getCurrentMember?.patient_id, reminderStartFilter, reminderEndFilter]);

  // const toggleDrawer = () => {
  //   toggleDrawerHandler(!isOpenDrawer);
  // };

  // const toggleDrawerViewType = (type: any) => {
  //   if (drawerViewtype !== type) {
  //     setDrawerViewtype(type);
  //     toggleDrawer();
  //   }
  // };

  // const handleSearch = (e: any) => {
  //   setSearchValue(e?.target?.value);
  //   if (e?.target?.value && e?.target?.value != "") {
  //     let ccMembers = [...copyAllMemberData];
  //     let d = ccMembers.filter(
  //       (row) =>
  //         Object.values(row).find((value: any) => {
  //           let val = isNaN(value)
  //             ? value.toLowerCase()
  //             : ("" + value).toLowerCase();
  //           return val?.indexOf((e?.target?.value).toLowerCase()) > -1;
  //         }) !== undefined
  //     );
  //     setAllMemberData(d);
  //   } else setAllMemberData(copyAllMemberData);
  // };

  const handleChange = (pagination: any, filters: any, sorter: any) => {
    console.log("EncountersData.handleChange");
    let sortType = sorter?.order === "ascend" ? ASC : sorter?.order === "descend" ? DESC : sorter?.order;

    sortType = sortType?.toLowerCase();
    setSortOrder(sortType);
    currentSortType.current = sortType;
    setSortByFilter(sorter?.columnKey);
    getEncounters({
      id: patientId,
      page: currentPage,
      limit: rowsPerPage,
      sortBy: sorter?.columnKey,
      sortType: sortType,
      searchBy: searchBy,
      searchKeyword: searchKeyword,
      startDate: reminderStartFilter,
      endDate: reminderEndFilter,
    });
  };

  const setPageSize = (e: number) => {
    console.log("EncountersData.setpageSize");
    setRowsPerPage(e);
    setCurrentPage(1);
    //Call API Again with page size as e and page as currentPage
    getEncounters({
      id: patientId,
      page: 1,
      limit: e,
      sortBy,
      sortType: sortOrder,
      startDate: reminderStartFilter,
      endDate: reminderEndFilter,
      searchBy: searchBy,
      searchKeyword: searchKeyword,
    });
  };

  const changeCurrentPage = (val: any) => {
    console.log("EncountersData.changeCurrentPage");
    setCurrentPage(val);
    //Call API Again with page size as rowsPerPage and page as val
    getEncounters({
      id: patientId,
      page: val,
      limit: rowsPerPage,
      sortBy,
      sortType: sortOrder,
      searchBy: searchBy,
      searchKeyword: searchKeyword,
      startDate: reminderStartFilter,
      endDate: reminderEndFilter,
    });
  };

  const handleReminderDateFilter = (range: any) => {
    console.log("EncountersData.handleReminderDateFilter", range);
    const reminderStartDate = range && range.length > 0 ? range[0].format("YYYY-MM") : undefined;
    const reminderEndDate = range && range.length > 0 ? range[1].format("YYYY-MM") : undefined;
    console.log(reminderStartDate,reminderEndDate )
    setReminderStartFilter(reminderStartDate);
    setReminderEndFilter(reminderEndDate);
    setCurrentPage(1);
  };
  
  const getClaimTypeColor = (claimType: any) => {
    return claimTypeLegendColors[claimType];
  };

  return (
    <Spin spinning={loadingForEncounter} indicator={<HealthemSpinner size={70} />}>
      <div className="ui-encounters-data">
        <Row style={{ justifyContent: "end", marginBottom: "16px" }}>
          <Col>
            <Row className="ui-encounters-data__dateOfService">
              <div className="reminderDateLabel">
                <span className="icon-calendar f18" />
                <span>Date Range :</span>
              </div>
              <RangePicker
                defaultValue={[moment(reminderStartFilter), moment(reminderEndFilter)]}
                picker="month"
                size="middle"
                format={"YYYY-MM"}
                allowClear={true}
                dropdownClassName="reminder-picker"
                onChange={(range) => {
                  handleReminderDateFilter(range);
                }}
                disabledDate={(current) => {
                  const monthsAgo = isCentric ? 11 : 11;
                  return current && (current < moment().subtract(monthsAgo, "months").startOf("month") || current > moment().endOf("month"));
                }}
              />
            </Row>
          </Col>
        </Row>
        <Card style={{ borderRadius: "10px", marginBottom: "8px" }} hoverable={false}>
          <h3>{isCentric ? "Last 12 Months" : "Last 12 Months"}</h3>
          <Row gutter={{ lg: 16, md: 16, sm: 8, xs: 8 }}>
            <Col span={8}>
              <Card.Grid style={{ minHeight: "230px", width: "100%" }} hoverable={false}>
                <div className="title-row">
                  <span style={{ color: "#091E42" }}>Insurance Claim Frequency</span>
                </div>
                {loadingForEncounter ? (
                  <></>
                ) : isEmpty(encounterData?.insuranceClaimFrequency) ? (
                  <div className="no-data">
                    <DataNotFound message={NO_DATA_FOUND} />
                  </div>
                ) : (
                  <div style={{ height: "140px" }}>
                    <LineChart data={encounterData?.insuranceClaimFrequency} />
                  </div>
                )}
              </Card.Grid>
            </Col>
            <Col span={8}>
              <Card.Grid style={{ minHeight: "230px", width: "100%", padding: 0, overflow: "hidden", paddingLeft: "1px" }} hoverable={false}>
                {/* <NotesModal patient_id={patientId} refreshDate={refreshDate} setNotesModal={setNotesModal}/>
               {showNotesModal && <Modal className="highCostPatient__modal_container high-cost-modal-close-style" visible={showNotesModal} footer={null} onCancel={() => setNotesModal(false)} wrapClassName={"highCostPatient__Modal"} 
               maskClosable={false} zIndex={30} maskStyle={{ position: "fixed",top: '0',width: '100vw',height: '100vh',zIndex: '25',left: '96.4px'}}>
                 <NotesModal patient_id={patientId} refreshDate={refreshDate} />
              </Modal>} */}
                <div className="title-row clear-filter-title" style={{ padding: "24px 24px 0 24px", marginBottom: 0 }}>
                  <span>Total Cost</span>
                  {!isEmpty(claim_type) && (
                    <span
                      className="clear-filter"
                      onClick={() => {
                        setClaim_type([]);
                        getEncounters({
                          id: patientId,
                          page: currentPage,
                          limit: rowsPerPage,
                          searchBy: searchBy,
                          searchKeyword: searchKeyword,
                          claimType: [],
                          startDate: reminderStartFilter,
                          endDate: reminderEndFilter,
                        });
                      }}
                    >
                      Clear Filter
                    </span>
                  )}
                </div>
                {loadingForEncounter ? (
                  <></>
                ) : isEmpty(encounterData?.totalCost) ? (
                  <div className="no-data">
                    <DataNotFound message={NO_DATA_FOUND} />
                  </div>
                ) : (
                  <div>
                    <DonutChart
                      type={"plot"}
                      data={encounterData?.totalCost}
                      handleClick={(claimType: any) => {
                        setClaim_type([claimType.split(":")[0]]);
                        setCurrentPage(1);
                        getEncounters({
                          id: patientId,
                          page: 1,
                          limit: rowsPerPage,
                          sortBy,
                          sortType: sortOrder,
                          searchBy: searchBy,
                          searchKeyword: searchKeyword,
                          claimType: [claimType.split(":")[0]],
                          startDate: reminderStartFilter,
                          endDate: reminderEndFilter,
                        });
                      }}
                      getClaimTypeColor={getClaimTypeColor}
                      isCostVisible={true}
                    />
                    {encounterData?.totalCost.map((item: any, index: number) => {
                      const legendColor = getClaimTypeColor(item.claim_type); 
                      const isNegative = item.cost < 0;

                      return item.cost !== undefined && item.cost !== null && item.cost !== 0 ? (
                        <div className="ui-encounters-data__donut-legends" key={item.claim_type}>
                          <div
                            className="ui-encounters-data__donut-legends__indicator"
                            style={{
                              backgroundColor: isNegative ? "white" : legendColor,
                              border: isNegative ? "2px solid red" : "none",
                            }}
                          ></div>
                          <span>{item.claim_type}: </span>
                          <span className={`ui-encounters-data__donut-legends__value ${isNegative ? "negative" : "positive"}`}>$ {fixedDecimal(item.cost, 2)}</span>
                          {isNegative && (
                            <Tooltip overlayStyle={{ maxWidth: "500px" }} title="Note: In case the Pharmacy Cost is negative, the Total Cost is same as Medical Cost in the above graph.">
                              <span className="pointer measureContainer__record__col__measureName__infoIcon">
                                <Icon name="info" colorOfBrand="#7A869A" height={"18"} width={"18"} />
                              </span>
                            </Tooltip>
                          )}
                        </div>
                      ) : null;
                    })}
                  </div>
                )}
              </Card.Grid>
              {/* <div className="as-on">
                <span> * As on {refreshDate && formatDisplayDate(refreshDate, "actualFormat", "dataRefreshDateFormatForEncountersData")}</span>
              </div> */}
            </Col>
            <Col span={8}>
              <Card.Grid style={{ height: "230px", width: "100%" }} hoverable={false}>
                <div className="title-row">
                  <table className="encounter-summary-table f14 clr-lightGrayColor">
                    {/* <tr>
                      <td className="summary-icon"><span className="icon icon-users"></span></td>
                      <td>{encounterData?.summary?.[0]?.readmissions} Readmissions in the Hospital</td>
                    </tr>
                    <tr>
                      <td className="summary-icon">
                        <span className="icon icon-home"></span>
                      </td>
                      <td>{encounterData?.summary?.[0]?.er_visit} ER events</td>
                    </tr>
                    <tr>
                      <td className="summary-icon"><span className="icon icon-clock"></span></td>
                      <td>{(encounterData?.summary?.[0]?.avg_stay)?.toLocaleString()} hrs is the average stay in Hospital</td>
                    </tr> */}
                    <tr>
                      <td className="summary-icon">
                        <span className="icon">
                          <Icon name="officeBag" />
                        </span>
                      </td>
                      <td> Assigned Office visits : {encounterData?.summary?.[0]?.office_visits ?? "--"}</td>
                    </tr>
                    <tr>
                      <td className="summary-icon">
                        <span className="icon">
                          <Icon name="patientOnBedTWithoutArrow" />
                        </span>
                      </td>
                      <td> Hospital admissions : {encounterData?.summary?.[0]?.hospital_admissions ?? "--"}</td>
                    </tr>
                    <tr>
                      <td className="summary-icon">
                        <span className="icon">
                          <Icon name="patientOnBed" />
                        </span>
                      </td>
                      <td> Hospital re-admissions : {encounterData?.summary?.[0]?.readmissions ?? "--"}</td>
                    </tr>
                    <tr>
                      <td className="summary-icon">
                        <span className="icon">
                          <Icon name="stethoscope" height="20" />
                        </span>
                      </td>
                      <td> ER visits : {encounterData?.summary?.[0]?.er_visit ?? "--"}</td>
                    </tr>
                    <tr>
                      <td className="summary-icon">
                        <span className="icon">
                          <Icon name="stethoscope" height="20" />
                        </span>
                      </td>
                      <td> ER admissions : {encounterData?.summary?.[0]?.er_admissions ?? "--"}</td>
                    </tr>
                  </table>
                  {/* <h3 className="f14 clr-lightGrayColor">
                    <span className="icon icon-users"></span>
                    <span style={{ marginLeft: "10px" }}>
                      {encounterData?.summary?.[0]?.readmissions}
                    </span>
                    <span style={{ marginLeft: "10px" }}>
                      Readmissions in the Hospital
                    </span>
                  </h3>
                  <h3 className="f14 clr-lightGrayColor">
                    <span className="icon icon-home"></span>
                    <span style={{ marginLeft: "10px" }}>
                      {encounterData?.summary?.[0]?.er_visit}
                    </span>
                    <span style={{ marginLeft: "10px" }}>ER events</span>
                  </h3>
                  <h3 className="f14 clr-lightGrayColor">
                    <span className="icon icon-clock"></span>
                    <span style={{ marginLeft: "10px" }}>
                      {encounterData?.summary?.[0]?.avg_stay}
                    </span>
                    <span style={{ marginLeft: "10px" }}>
                      hrs is the average stay in Hospital
                    </span>
                  </h3> */}
                </div>
                <div></div>
              </Card.Grid>
            </Col>
          </Row>
        </Card>
        <Card>
          <Row style={{ marginBottom: "16px", alignItems: "center" }}>
            <Col span={23}>
              <span className="labelText clr-n100">All Encounters</span>
            </Col>
            <Col span={1} className="ui-encounters-data">
              {!isEmpty(alllMemberData) && (
                <Tooltip title="Download XLS" overlayClassName="download-tooltip">
                  <i className="btn-icon icon-download clr-n125" style={{ width: "20px", height: "42px" }} onClick={() => downloadEncountersTable()} />
                </Tooltip>
              )}
            </Col>
            {/* <Col span={5}>
            <div className="ml-auto flex ">
              <Input
                  placeholder="Search"
                  className="encounter-search"
                  prefix={
                    <span
                      style={{
                        marginRight: "6px",
                        marginTop: "6px",
                        fontSize: "18px",
                        borderRadius: "4px"
                      }}
                      className="icon-search clr-lightGrayColor"
                    />
                  }
                  onChange={handleSearch}
                  // onPressEnter={() => {handleSearch}}
                />
            </div>
          </Col>
          <Col span={1}>
            <Badge>
              <span
                className={`btn-icon icon-filter f18 ${
                  appliedFilters ? "tableFilterApplied" : ""
                }`}
                onClick={() => toggleDrawerViewType(layerViews[0])}
              />
            </Badge>
          </Col> */}
          </Row>
          <Row>
            <Col span={24}>
              <Table
                key={`${reminderStartFilter}${reminderEndFilter}`}
                bordered={true}
                pagination={false}
                // loading={loading}
                columns={columns}
                dataSource={alllMemberData}
                onChange={handleChange}
                locale={TableLocale}
                scroll={{ x: 'max-content' }}

              />
              <div className="pagination">
                <div>
                  Show
                  <Select defaultValue={rowsPerPage} style={{ width: 64, margin: "8px 8px" }} onChange={(e) => setPageSize(e)} suffixIcon={<CaretDownOutlined />}>
                    {rowsPerPageArray.map((val) => (
                      <Select.Option key={val} value={val}>
                        {val}
                      </Select.Option>
                    ))}
                  </Select>
                  rows per page
                </div>
                {alllMemberData?.length > 0 && (
                  <Pagination
                    total={totalPages}
                    showTotal={(total, range) => (
                      <>
                        <span style={{ color: "#091e42" }}>
                          {rowsPerPage * currentPage - (rowsPerPage - 1)} -{" "}
                          {rowsPerPage * currentPage > alllMemberData?.length
                            ? alllMemberData?.length + rowsPerPage * currentPage - (rowsPerPage - 1) - 1
                            : rowsPerPage * currentPage + rowsPerPage * currentPage - (rowsPerPage - 1) - 1}
                          {/* {range[0]} - {range[1]} */}
                          {/* {range.map(r=>console.log(r))} */}
                        </span>
                        <span> of {totalPages}</span>
                      </>
                    )}
                    key={`${totalPages} + ${rowsPerPage}`}
                    defaultPageSize={rowsPerPage}
                    defaultCurrent={currentPage}
                    current={currentPage}
                    showSizeChanger={false}
                    onChange={(e) => {
                      changeCurrentPage(e);
                    }}
                  />
                )}
              </div>
            </Col>
          </Row>
        </Card>
      </div>
    </Spin>
  );
};

export default withAITracking(reactPlugin, EncountersData);
